let wakeLock = null;
export class System {
    constructor() {
    }
    static getInstance() {
        if (!System.instance) {
            System.instance = new System();
        }
        return System.instance;
    }
    static isIos() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }
    ;
    static isInStandaloneMode() {
        return ("standalone" in window.navigator &&
            window.navigator.standalone);
    }
    ;
    async doWakelock(seconds) {
        try {
            wakeLock = await navigator.wakeLock.request();
            console.log('wakelock released', wakeLock.released);
            wakeLock.addEventListener('release', () => {
                console.log('wakelock released', wakeLock?.released);
            });
        }
        catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
        window.setTimeout(() => {
            wakeLock?.release();
            wakeLock = null;
        }, seconds * 1000);
    }
    async copyToClipboard(text) {
        return await navigator.clipboard.writeText(text)
            .then((_) => { return true; })
            .catch((_) => { return false; });
    }
    shareAvailable() {
        return navigator.share;
    }
    share(title, text, url) {
        navigator.share({
            title: title,
            text: text,
            url: url,
        })
            .then((_) => { return undefined; })
            .catch((_) => { return undefined; }); // most likely abort sharing
    }
    webPushAvailable() {
        return (("Notification" in window)) ? true : false;
    }
    webPushAllowed() {
        if (this.webPushAvailable()) {
            return ((Notification.permission === "granted")) ? true : false;
        }
        return false;
    }
    async webPushRequest() {
        await Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                console.log("webpush is granted");
                return true;
            }
            else {
                console.log("webpush is denied");
                return false;
            }
        });
    }
}
//# sourceMappingURL=system.service.js.map